// extracted by mini-css-extract-plugin
module.exports = {"Infobox":"RXETqx","customIcon":"_3o9QFF","text":"_1Lc_vK","entitlementCue":"_1ABJL9"};